import { clsx } from 'clsx';

import { Testimonials } from '@/components/testimonials/testimonials.tsx';
import type { TestimonialsData } from '@/lib/api/requests.ts';

import { Section } from '../section/index.ts';

export const TestimonialsSection = (props: { data: TestimonialsData }) => {
  return (
    <Section.Container
      className={clsx(
        'w-full bg-white text-v1-background-200',
        '[--section-bleed:--spacing(15/2)]', // Half of the size of the floating quote image
      )}
    >
      <Section.Content className="py-8">
        <Testimonials data={props.data} />
      </Section.Content>
    </Section.Container>
  );
};
